// 游戏服务 - 处理游戏数据的获取和管理
import newGameData from '../../data/new_game_data.json'

export const gameService = {
  // 获取所有游戏
  getAllGames() {
    try {
      return newGameData || []
    } catch (error) {
      console.error('Error getting all games:', error)
      return []
    }
  },

  // 根据名称获取游戏详情
  getGameByName(name) {
    return newGameData.find(game => game.name === name)
  },

  // 根据分类筛选游戏
  getGamesByCategory(category) {
    return newGameData.filter(game => 
      game.category && game.category.toLowerCase() === category.toLowerCase()
    )
  },

  // 搜索游戏
  searchGames(query) {
    const searchTerm = query.toLowerCase()
    return newGameData.filter(game => 
      game.name.toLowerCase().includes(searchTerm) ||
      game.description.toLowerCase().includes(searchTerm) ||
      (game.category && game.category.toLowerCase().includes(searchTerm))
    )
  },

  // 获取热门游戏（前10个）
  getPopularGames() {
    try {
      return newGameData ? newGameData.slice(0, 10) : []
    } catch (error) {
      console.error('Error getting popular games:', error)
      return []
    }
  },

  // 获取游戏分类
  getGameCategories() {
    try {
      const categories = new Set()
      if (newGameData && Array.isArray(newGameData)) {
        newGameData.forEach(game => {
          if (game.category) {
            categories.add(game.category)
          }
        })
      }
      return Array.from(categories).sort()
    } catch (error) {
      console.error('Error getting game categories:', error)
      return []
    }
  },

  // 获取最新游戏
  getLatestGames(limit = 10) {
    try {
      return newGameData ? newGameData.slice(0, limit) : []
    } catch (error) {
      console.error('Error getting latest games:', error)
      return []
    }
  },

  // 根据创建日期筛选游戏
  getGamesByDateRange(startDate, endDate) {
    return newGameData.filter(game => {
      const gameDate = new Date(game.create_date)
      const start = new Date(startDate)
      const end = new Date(endDate)
      return gameDate >= start && gameDate <= end
    })
  }
}

// 为了保持向后兼容性，保留原有的导出方式
export const getGames = () => {
  return gameService.getAllGames()
}

export const getGameById = (id) => {
  return gameService.getGameByName(id)
}

export default gameService 